import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/features'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.FeaturesPageProps>()(Page.Features)
